// import Swiper JS
import { sliderStyles } from "./custom";

jQuery(document).ready(function ($) {
  class Slider {
    constructor(sliderElement) {
      this.sliderElement = sliderElement;
      this.style = sliderElement.parentNode.getAttribute("data-slider-style");

      this._init();
    }

    _init() {
      if (
        !this.style ||
        !this.sliderElement ||
        !sliderStyles[this.style].Slider
      ) {
        console.error("luther slider could not be initilized");
        return false;
      }

      this.instance = new sliderStyles[this.style].Slider(this.sliderElement);
    }
  }

  window.luther = window.luther || {};
  window.luther.sliders = [];

  $(".wp-block-luther-slider >.swiper").each((i, el) => {
    let sliderElement = new Slider(el);
    window.luther.sliders.push(sliderElement);
  });
});
